// @ts-nocheck

function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initRadioSidePanel() {

/**
 * Índice de recursos da rádio — drawer lateral (radios.pro).
 *
 * Escaneia os elementos [data-rp-section] presentes no DOM e monta um índice
 * navegável. Como só marcamos seções que realmente renderizam (com dado), o
 * painel reflete automaticamente a disponibilidade — sem duplicar lógica.
 * Re-escaneia quando o conteúdo extra (AJAX), banners e áudios chegam.
 *
 * Nota: algumas seções (contatos, plataformas, ações) ficam aninhadas dentro
 * do <section class="radio-detail-hero"> (marcado "info") no HTML da página —
 * por isso o destaque ativo usa a POSIÇÃO vertical de cada elemento (não
 * IntersectionObserver por sobreposição), que continua correta mesmo com
 * elementos-filho fisicamente dentro de um container maior.
 */
(function () {
    'use strict';

    var panel = document.getElementById('rp-side-panel');
    var nav = document.getElementById('rp-side-panel-nav');
    var pinBtn = document.getElementById('rp-side-panel-pin');
    var fab = document.getElementById('rp-side-panel-fab');
    if (!panel || !nav) return;

    // Categorias — define ordem E agrupamento visual no menu.
    // "platforms" não entra no índice (fica só como conteúdo da página).
    var GROUPS = [
        { title: 'Sobre a rádio', keys: ['info', 'contacts'] },
        { title: 'Conteúdo da página', keys: ['banners', 'schedule', 'statistics', 'enrichment', 'news', 'contents'] },
        { title: 'Recursos do painel', keys: ['audios'] },
        { title: 'Ações', keys: ['actions'] }
    ];
    var ORDER = GROUPS.reduce(function (acc, g) { return acc.concat(g.keys); }, []);

    var ICONS = {
        info: 'fa-circle-info', contact: 'fa-headset', apps: 'fa-table-cells-large',
        calendar: 'fa-calendar-days', chart: 'fa-chart-line', sparkles: 'fa-wand-magic-sparkles',
        news: 'fa-newspaper', grid: 'fa-shapes', image: 'fa-image', audio: 'fa-podcast',
        shield: 'fa-shield-halved'
    };

    var HEADER_OFFSET = 88;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = function () { return window.matchMedia('(max-width:900px)').matches; };

    var sectionEls = [];
    var rafPending = false;

    function isUsable(el) {
        if (!el || el.hasAttribute('hidden')) return false;
        // Precisa ter algum conteúdo real (evita shells vazios). Não checamos
        // offsetParent/getClientRects aqui: alguns blocos (ex. estatísticas)
        // chegam com <script>/<style> como primeiros filhos (CDN do Chart.js)
        // e o layout pode levar um instante para assentar — isso não deveria
        // esconder o bloco, que já tem markup visível real por baixo.
        return el.children.length > 0 || (el.textContent || '').trim().length > 0;
    }

    function collect() {
        var found = [];
        var seen = {};
        var els = document.querySelectorAll('[data-rp-section]');
        for (var i = 0; i < els.length; i++) {
            var el = els[i];
            var key = el.getAttribute('data-rp-section');
            if (!key || seen[key]) continue;
            if (ORDER.indexOf(key) < 0) continue; // fora das categorias = não entra no índice
            if (!isUsable(el)) continue;
            seen[key] = true;
            found.push({
                key: key,
                el: el,
                label: el.getAttribute('data-rp-label') || key,
                icon: ICONS[el.getAttribute('data-rp-icon')] || 'fa-circle'
            });
        }
        found.sort(function (a, b) {
            var ia = ORDER.indexOf(a.key); var ib = ORDER.indexOf(b.key);
            if (ia < 0) ia = 99; if (ib < 0) ib = 99;
            return ia - ib;
        });
        return found;
    }

    // Enquanto não-nulo, o scroll-spy ignora a posição e mantém esta chave
    // ativa — usado durante o scroll suave disparado por clique, para o botão
    // clicado não "piscar" voltando ao item anterior no meio da animação.
    var pinnedKey = null;
    var pinnedClearTimer = null;

    function clearPinned() {
        pinnedKey = null;
        if (pinnedClearTimer) { clearTimeout(pinnedClearTimer); pinnedClearTimer = null; }
        // Não recalcula aqui de propósito: em páginas curtas, o destino do
        // clique pode já estar perto do fim, e recalcular na hora "rouba" o
        // destaque de volta pra última seção. O item clicado fica ativo até
        // o próximo scroll de verdade do usuário (via onScroll normal).
    }

    function scrollToEl(el, key) {
        var y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        if (key) {
            pinnedKey = key;
            setActive(key);
        }
        window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
        if (!key) return;
        if (pinnedClearTimer) clearTimeout(pinnedClearTimer);
        if ('onscrollend' in window) {
            var onEnd = function () {
                window.removeEventListener('scrollend', onEnd);
                clearPinned();
            };
            window.addEventListener('scrollend', onEnd);
            // Rede de segurança: se 'scrollend' não disparar por algum motivo
            // (ex. scroll interrompido), libera o pin de qualquer forma.
            pinnedClearTimer = setTimeout(clearPinned, 1500);
        } else {
            pinnedClearTimer = setTimeout(clearPinned, reduceMotion ? 50 : 700);
        }
    }

    function setActive(key) {
        var items = nav.querySelectorAll('.rp-nav-item');
        for (var i = 0; i < items.length; i++) {
            items[i].classList.toggle('is-active', items[i].getAttribute('data-key') === key);
        }
    }

    /**
     * Scroll-spy por POSIÇÃO: entre as seções cujo topo já passou da linha de
     * referência (header offset), a ativa é a de topo mais próximo — ou seja,
     * a última que o usuário "cruzou" ao rolar. Funciona corretamente mesmo
     * com seções aninhadas (ex.: contatos/plataformas dentro do hero), porque
     * usa a posição geométrica real de cada elemento, não sobreposição de área.
     *
     * Caso especial: perto do fim da página, a última seção pode nunca ter
     * seu topo empurrado até a linha de referência (não sobra espaço pra
     * rolar) — nesse caso, ativa direto a última seção rastreada.
     */
    function updateActiveByScroll() {
        rafPending = false;
        if (pinnedKey) { setActive(pinnedKey); return; }
        if (!sectionEls.length) return;

        var doc = document.documentElement;
        var atBottom = (window.innerHeight + window.pageYOffset) >= (doc.scrollHeight - 3);
        if (atBottom) {
            setActive(sectionEls[sectionEls.length - 1].key);
            return;
        }

        var threshold = HEADER_OFFSET + 16;
        var current = sectionEls[0];
        var bestTop = -Infinity;
        for (var i = 0; i < sectionEls.length; i++) {
            var top = sectionEls[i].el.getBoundingClientRect().top;
            if (top <= threshold && top > bestTop) {
                bestTop = top;
                current = sectionEls[i];
            }
        }
        setActive(current.key);
    }

    function onScroll() {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(updateActiveByScroll);
    }

    function render() {
        var sections = collect();
        sectionEls = sections;

        // precisa de pelo menos 2 recursos para valer a pena mostrar o índice
        if (sections.length < 2) {
            panel.hidden = true;
            if (fab) fab.hidden = true;
            return;
        }

        var byKey = {};
        sections.forEach(function (s) { byKey[s.key] = s; });

        nav.innerHTML = '';
        GROUPS.forEach(function (g) {
            var present = g.keys.map(function (k) { return byKey[k]; }).filter(Boolean);
            if (!present.length) return;

            var wrap = document.createElement('div');
            wrap.className = 'rp-nav-group';
            var t = document.createElement('div');
            t.className = 'rp-nav-group__title';
            t.textContent = g.title;
            wrap.appendChild(t);

            present.forEach(function (s) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'rp-nav-item';
                b.setAttribute('data-key', s.key);
                var ic = document.createElement('span');
                ic.className = 'rp-nav-item__ic';
                ic.innerHTML = '<i class="fas ' + s.icon + '" aria-hidden="true"></i>';
                var lb = document.createElement('span');
                lb.className = 'rp-nav-item__label';
                lb.textContent = s.label;
                b.appendChild(ic);
                b.appendChild(lb);
                b.addEventListener('click', function () {
                    scrollToEl(s.el, s.key);
                    if (isMobile()) closeMobile();
                });
                wrap.appendChild(b);
            });
            nav.appendChild(wrap);
        });

        panel.hidden = false;
        if (fab) fab.hidden = !isMobile();
        updateActiveByScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // ---- Pin (desktop) ----
    if (pinBtn) {
        pinBtn.addEventListener('click', function () {
            var pinned = panel.classList.toggle('is-pinned');
            pinBtn.setAttribute('aria-pressed', pinned ? 'true' : 'false');
        });
    }

    // ---- Mobile: FAB + backdrop ----
    var backdrop = null;
    function ensureBackdrop() {
        if (backdrop) return backdrop;
        backdrop = document.createElement('div');
        backdrop.className = 'rp-side-panel__backdrop';
        backdrop.addEventListener('click', closeMobile);
        document.body.appendChild(backdrop);
        return backdrop;
    }
    function openMobile() {
        panel.classList.add('is-mobile-open');
        ensureBackdrop().classList.add('is-visible');
        if (fab) fab.setAttribute('aria-expanded', 'true');
    }
    function closeMobile() {
        panel.classList.remove('is-mobile-open');
        if (backdrop) backdrop.classList.remove('is-visible');
        if (fab) fab.setAttribute('aria-expanded', 'false');
    }
    if (fab) {
        fab.addEventListener('click', function () {
            if (panel.classList.contains('is-mobile-open')) closeMobile(); else openMobile();
        });
    }
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.classList.contains('is-mobile-open')) closeMobile();
    });
    window.addEventListener('resize', function () {
        if (!isMobile()) closeMobile();
        if (fab) fab.hidden = panel.hidden || !isMobile();
    });

    // ---- Re-scan quando o DOM muda (extra AJAX, banners, áudios) ----
    var rescanTimer = null;
    function scheduleRender() {
        if (rescanTimer) clearTimeout(rescanTimer);
        rescanTimer = setTimeout(render, 140);
    }
    function observe(id) {
        var el = document.getElementById(id);
        if (!el || !('MutationObserver' in window)) return;
        new MutationObserver(scheduleRender).observe(el, {
            childList: true, subtree: true, attributes: true,
            attributeFilter: ['hidden', 'style', 'class']
        });
    }
    observe('radio-detail-extra');
    observe('radio-banners-carousel');
    observe('rd-promo-audios');
    document.addEventListener('rp-sidepanel-refresh', scheduleRender);

    render();
    // Rede de segurança: além do MutationObserver, continua reconferindo por
    // mais tempo — cobre redes mais lentas (fetch cross-origin pro
    // appradio.pro, CDN do Chart.js, etc.) onde o conteúdo extra/banners/
    // áudios ainda não chegou dentro da janela original de 1-3s. Para quando
    // a contagem de seções fica estável por 2 checagens seguidas, ou após
    // ~15s (não fica passando pra sempre).
    var pollTries = 0;
    var pollLastCount = -1;
    var pollStableRounds = 0;
    var pollTimer = setInterval(function () {
        pollTries++;
        var count = document.querySelectorAll('[data-rp-section]').length;
        if (count === pollLastCount) {
            pollStableRounds++;
        } else {
            pollStableRounds = 0;
            pollLastCount = count;
            scheduleRender();
        }
        if (pollStableRounds >= 2 || pollTries >= 15) {
            clearInterval(pollTimer);
        }
    }, 1000);
})();

}
